@let config = resolvedConfig();
<div
  class="mx-auto pb-5"
  [style.backgroundColor]="config.background_color"
>
  @let vm = vm$ | async;
  @if (vm && !vm?.isShopLoading && vm.shop) {
    @if (!isOrderingAllowed) {
      <div class="my-5 px-5 py-5">
        <div class="rounded rounded-md bg-highlight-50 p-4 font-accent">
          <p>
            {{ vm.shop.name }}
            {{ 'shop-page.not-available' | translate }}
          </p>
          @if (availableAtMessage) {
            <p class="mt-4">
              {{ 'shop-page.back-in-duration' | translate: { duration: availableAtMessage } }}
            </p>
          }
        </div>
        @if (shouldBeAvailableNow) {
          <div class="mt-2 flex w-full flex-row justify-center">
            <app-button-atom
              type="light"
              size="S"
              [label]="'shop-page.reload-page-button' | translate"
              (clickEventEmitter)="reloadPage()"
            ></app-button-atom>
          </div>
        }
      </div>
    }

    @if (isOrderingAllowed && vm.treeTabsOfCatalogCategory) {
      @if (vm.treeTabsOfCatalogCategory.length) {
        <div
          appScrollSpy
          [activeSection]="activeItemId()"
          (activeSectionChange)="activeItemId.set($event)"
          [ids]="vm.categoriesId"
          [offset]="scrollSpyOffset()"
          #appScrollSpy="appScrollSpy"
        >
          <div
            class="sticky z-10"
            #categoryTabsContainer
            [style.top]="config.category_list_top + 'px'"
            [style.backgroundColor]="categoriesBackgroundColor()"
            [ngClass]="isBurgerNavigationOpen ? 'fixed z-120' : 'sticky'"
          >
            <app-tab-list-atom
              [treeTabs]="vm.treeTabsOfCatalogCategory"
              [activeItemId]="activeItemId()"
              (activeItemIdChange)="appScrollSpy.scrollToSectionId($event)"
              [config]="resolvedConfig()"
              [isNotched]="isNotched"
              (tabChange)="onTabClick($event)"
              (isBurgerNavigationOpen)="toggleBurgerMenuNavigation($event)"
            >
            </app-tab-list-atom>

            @if (filtereableLabels.length > 0) {
              <div
                class="shadow-xs mx-auto w-full overflow-x-auto shadow scrollbar-hide"
                [style.backgroundColor]="categoriesBackgroundColor()"
              >
                <ul class="flex flex-row gap-4 px-5 py-3 lg:py-4 lg:pl-12">
                  @for (filtereableLabel of filtereableLabels; track filtereableLabel.name) {
                    <li
                      class="cursor-pointer"
                      (click)="selectLabel(filtereableLabel)"
                    >
                      <app-tag-atom
                        [color]="
                          vm.selectedLabel === filtereableLabel
                            ? vm.filterColors.activeColors
                            : vm.filterColors.inactiveColors
                        "
                        [text]="filtereableLabel.name"
                      ></app-tag-atom>
                    </li>
                  }
                </ul>
              </div>
            }
          </div>

          @if (
            config.display_allergen_and_tag_filters &&
            hasCatalogFilterOptions(vm.catalogFilterOptions)
          ) {
            <div
              #catalogFiltersBar
              class="border-b border-neutral-200"
              [class.sticky]="catalogFilters.applied().length > 0"
              [class.z-10]="catalogFilters.applied().length > 0"
              [style.top.px]="
                catalogFilters.applied().length > 0 ? catalogFiltersStickyTop() : null
              "
              [style.backgroundColor]="categoriesBackgroundColor()"
            >
              <div class="flex items-center gap-3 px-5 py-3 lg:pl-12">
                <button
                  type="button"
                  class="inline-flex shrink-0 items-center gap-2 rounded-full border border-neutral-300 px-3 py-1.5 font-base text-sm text-neutral-800"
                  (click)="openCatalogFilters()"
                >
                  <i
                    class="icon icon-filter"
                    aria-hidden="true"
                  ></i>
                  @if (catalogFilters.applied().length > 0) {
                    <span
                      class="notranslate inline-flex h-5 min-w-5 items-center justify-center rounded-full bg-primary-600 px-1 text-xs text-white lg:hidden"
                    >
                      {{ catalogFilters.applied().length }}
                    </span>
                    <span class="hidden lg:inline">
                      {{ 'catalog-filters.trigger' | translate }}
                    </span>
                    <span
                      class="notranslate hidden h-5 min-w-5 items-center justify-center rounded-full bg-primary-600 px-1 text-xs text-white lg:inline-flex"
                    >
                      {{ catalogFilters.applied().length }}
                    </span>
                  } @else {
                    <span>{{ 'catalog-filters.trigger' | translate }}</span>
                  }
                </button>
                @if (catalogFilters.applied().length > 0) {
                  <ul class="flex min-w-0 flex-1 gap-2 overflow-x-auto scrollbar-hide">
                    @for (filter of catalogFilters.applied(); track filter.kind + ':' + filter.id) {
                      <li class="shrink-0">
                        <button
                          type="button"
                          class="inline-flex items-center gap-2 rounded-full bg-primary-100 px-3 py-1.5 font-base text-sm text-neutral-900 lg:border lg:border-neutral-300 lg:bg-transparent"
                          (click)="removeCatalogFilter(filter)"
                        >
                          @if (filter.mode === 'exclude') {
                            {{
                              'catalog-filters.without'
                                | translate
                                  : {
                                      name:
                                        filter.kind === 'allergen'
                                          ? ('allergens.' + filter.name | translate)
                                          : filter.name,
                                    }
                            }}
                          } @else {
                            {{ filter.name }}
                          }
                          <i
                            class="icon icon-cross text-xs"
                            aria-hidden="true"
                          ></i>
                        </button>
                      </li>
                    }
                  </ul>
                  <button
                    type="button"
                    class="hidden shrink-0 font-base text-sm underline lg:inline"
                    (click)="clearCatalogFilters()"
                  >
                    {{ 'filters.delete-all' | translate }}
                  </button>
                }
              </div>
            </div>
          }

          <div class="pt-6">
            @for (
              treeCategoryWithProduct of vm.categoriesWithProductsFilteredByLabel;
              track treeCategoryWithProduct.id
            ) {
              <app-category-factory
                [class.category-horizontal-highlight]="
                  treeCategoryWithProduct.category.display_type === 'horizontal_highlight'
                "
                [isHorizontalHighlight]="
                  treeCategoryWithProduct.category.display_type === 'horizontal_highlight'
                "
                [componentClass]="
                  treeCategoryWithProduct.category | appFn: getCategoryComponentClass
                "
                [treeCategoryWithProduct]="treeCategoryWithProduct"
                [isOrderingAllowed]="isOrderingAllowed"
                [categoryNameColor]="config.category_name_color"
                [categoryDescriptionColor]="config.category_description_color"
                [highlightCategoryNameColor]="config.highlight_category_name_color"
                [highlightCategoryBackgroundColor]="config.highlight_category_background_color"
                [productNameColor]="
                  {
                    field: 'highlight_product_name_color',
                    fallback: config.product_name_color,
                    category: treeCategoryWithProduct.category,
                  } | appFn: getProductColor
                "
                [productDescriptionColor]="
                  {
                    field: 'highlight_product_description_color',
                    fallback: config.product_description_color,
                    category: treeCategoryWithProduct.category,
                  } | appFn: getProductColor
                "
                [productPriceColor]="
                  {
                    field: 'highlight_product_price_color',
                    fallback: config.product_price_color,
                    category: treeCategoryWithProduct.category,
                  } | appFn: getProductColor
                "
                [productImagePlaceholderColor]="
                  {
                    field: 'highlight_product_image_placeholder_color',
                    fallback: config.product_image_placeholder_color,
                    category: treeCategoryWithProduct.category,
                  } | appFn: getProductColor
                "
                [productBorderColor]="
                  {
                    field: 'highlight_product_border_color',
                    fallback: config.product_border_color,
                    category: treeCategoryWithProduct.category,
                  } | appFn: getProductColor
                "
                [productBackgroundColor]="
                  {
                    field: 'highlight_product_background_color',
                    fallback: config.product_background_color,
                    category: treeCategoryWithProduct.category,
                  } | appFn: getProductColor
                "
                [productHoverColors]="config.product_hover_colors"
                [tagColors]="vm.tagColors"
                (navigateTo)="
                  isOrderingAllowed ? navigateTo($event, treeCategoryWithProduct.category.id) : null
                "
              ></app-category-factory>
            }
          </div>
        </div>
      }
    }

    @if (catalogFiltersOpen() && vm.catalogFilterOptions) {
      <app-shop-catalog-filters-dialog
        [options]="vm.catalogFilterOptions"
        [categories]="vm.categoriesBeforeCatalogFilters ?? []"
        [selection]="catalogFilters.applied()"
        (dismissed)="catalogFiltersOpen.set(false)"
        (applied)="applyCatalogFilters($event)"
      ></app-shop-catalog-filters-dialog>
    }

    @if (
      config.display_back_shop_list_button_mobile || config.display_back_shop_list_button_desktop
    ) {
      <div
        [ngClass]="
          config.display_back_shop_list_button_mobile &&
          config.display_back_shop_list_button_desktop
            ? 'block'
            : config.display_back_shop_list_button_mobile &&
                !config.display_back_shop_list_button_desktop
              ? 'block lg:hidden'
              : !config.display_back_shop_list_button_mobile &&
                  config.display_back_shop_list_button_desktop
                ? 'hidden lg:block'
                : 'hidden'
        "
      >
        @if (isScrollingDown && config.shop_list_url) {
          <div
            class="fixed bottom-16 right-5 z-50 w-auto"
            [class.bottom-32]="(cartProducts$ | async)?.length"
          >
            <div class="flex flex-row-reverse">
              @if (config.back_shop_list_button_text) {
                <app-button-atom
                  [label]="config.back_shop_list_button_text"
                  [thickSize]="'S'"
                  [icon]="'icon-bullet-list'"
                  (click)="backShopListButton(config.shop_list_url)"
                  [type]="'light'"
                  [overrideBgColor]="config.shop_list_button_color"
                  [overrideTextColor]="config.shop_list_button_text_color"
                >
                </app-button-atom>
              }
              @if (!config.back_shop_list_button_text) {
                <app-rounded-icon-button
                  icon="icon-bullet-list"
                  [color]="'primary'"
                  (onClick)="backShopListButton(config.shop_list_url)"
                ></app-rounded-icon-button>
              }
            </div>
          </div>
        }
      </div>
    }
  } @else {
    <div class="pt-8">
      @for (i of getLoadingItemsArray(); track $index) {
        <div class="flex h-32 cursor-pointer justify-between bg-white px-5 py-3">
          <div class="w-full">
            <p class="mb-2 h-6 w-32 animate-pulse rounded bg-neutral-200"></p>
            <p class="mb-2 h-4 w-44 animate-pulse rounded bg-neutral-50"></p>
          </div>
          <div class="height-fit-content relative">
            <div class="h-28 w-28 animate-pulse rounded bg-neutral-50"></div>
          </div>
        </div>
      }
    </div>
  }

  @if ((vm?.warningMessages ?? warningMessages)?.length) {
    <div class="my-5 px-5 py-5">
      @for (message of vm?.warningMessages ?? warningMessages; track message) {
        <p class="rounded rounded-sm bg-highlight-50 p-4 font-accent">
          {{ message }}
        </p>
      }
    </div>
  }
</div>
